import { render, staticRenderFns } from "./Useredit.vue?vue&type=template&id=54b57746&"
import script from "./Useredit.vue?vue&type=script&lang=js&"
export * from "./Useredit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports